import { Component, OnInit } from '@angular/core';
import {ConsultasService} from '../../servicios/consultas/consultas.service'
import { Convocatorias, ConvocatoriasHead } from '../../modelos/consultas/consultas';

@Component({
  selector: 'app-convocatorias',
  templateUrl: './convocatorias.component.html',
  styleUrls: ['./convocatorias.component.scss'],
  providers:[ConsultasService]

})
export class ConvocatoriasComponent implements OnInit {

  private currentYear: number;

  //public convocatorias : Convocatorias[] ;

  displayedColumns: string[] = ['codigo','cargo','dependencia','perfil','aptosEntrevista','comuncicado','resultadoFinal'];
 

  
  
  dataSource : Convocatorias[] ;
  convocatoriasHead : ConvocatoriasHead[] ;

  constructor(private consultasService : ConsultasService) {  
    this.currentYear = new Date().getFullYear();
    
  }

  ngOnInit(): void {

    this.consultasService.getConvocatorias$().subscribe(
      (data)=>{

        this.dataSource=data        

      }
    )


    this.consultasService.getConvocatoriashead$(this.currentYear).subscribe(
      (data)=>{
        this.convocatoriasHead=data;
      }

    )

  }

}
